import { h, JSX } from "preact";

import CSSProperties from "../../../../foundation/model/CSSProperties";
import classname from "../../../../foundation/utils/classname";

import IconChevronDown from "../../Icons/IconChevronDown";
import IconChevronUp from "../../Icons/IconChevronUp";

import { SECTION_LINE_WIDTH } from "./specs";

import styles from "./SectionLine.module.css";

type NativeDivProps = JSX.HTMLAttributes<HTMLDivElement>;

interface Props extends NativeDivProps {
    style?: CSSProperties;
    collapsed: boolean;
    clickable?: boolean;
    onClick?: (ev: Event) => void;
}

function SectionLine({
    class: cssClass,
    style: styleProp,
    collapsed,
    clickable,
    onClick,
    ...nativeDivProps
}: Props) {
    const style = {
        ...styleProp,
        "--section-line-width": `${SECTION_LINE_WIDTH}px`
    } as CSSProperties;

    function handleClick(event: Event) {
        if (!clickable) {
            return;
        }

        onClick?.(event);
    }

    return (
        <div
            {...nativeDivProps}
            class={classname(styles.sectionLine, cssClass, {
                [styles.collapsed]: collapsed,
                [styles.clickable]: clickable
            })}
            style={style}
            onClick={handleClick}>
            <div class={styles.sectionLineContent}>
                <IconChevronDown class={styles.chevron}/>
                <IconChevronUp class={styles.chevron}/>
            </div>
        </div>
    );
}

export default SectionLine;
